module.exports = __webpack_public_path__ + "static/dentistbanner-3e790f4ffe7b6314049a98cf1f8f4810.jpg";